// components/FileViewer.jsx
import React, { useState, useEffect } from 'react';
import { FileText, Image, File, Download, ExternalLink, Trash2, Loader, AlertCircle, RefreshCw } from 'lucide-react';
import { contabilidadApi } from '../services/api';

//GENERADO Y VERIFICADO CON IA
const FileViewer = ({ IdCarpeta, isEntregaParcial = false, idEntrega = "" ,nombreEmpresa}) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar archivos al montar el componente o cuando cambian los IDs
  useEffect(() => {
    if (IdCarpeta) {
      loadFiles();
    }
  }, [IdCarpeta]);

  // Función para cargar archivos desde Google Drive
  const loadFiles = async () => {
    console.log("cargando archivos ", IdCarpeta);
    try {
      setIsLoading(true);
      setError(null);
      
      console.log("a archivos");
      const response = await contabilidadApi.getArchivosEntregaTutor(IdCarpeta,isEntregaParcial,idEntrega,nombreEmpresa);
      
      if (response.success) {
        console.log("se encontraron archivos", response.archivos);
        // Asegúrate de que response.archivos sea un array
        // Si no es un array o es undefined, usa un array vacío
        setFiles(Array.isArray(response.archivos) ? response.archivos : []);
      } else {
        console.log("porque no encuentra archivos");
        setError('No se pudieron cargar los archivos');
        setFiles([]);
      }
    } catch (error) {
      console.error('Error al cargar archivos:', error);
      setError('Error al cargar los archivos. Por favor, intenta de nuevo.');
      setFiles([]);
    } finally {
      setIsLoading(false);
    }
  };


  // Obtener ícono según tipo de archivo
  const getFileIcon = (mimeType) => {
    if (!mimeType) return <File size={20} className="text-gray-500" />;
    
    if (mimeType.startsWith('image/')) {
      return <Image size={20} className="text-blue-500" />;
    } else if (mimeType === 'application/pdf') {
      return <FileText size={20} className="text-red-500" />;
    } else if (mimeType.includes('word') || mimeType.includes('document')) {
      return <FileText size={20} className="text-blue-600" />;
    } else if (mimeType.includes('sheet') || mimeType.includes('excel')) {
      return <FileText size={20} className="text-green-600" />;
    } else if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) {
      return <FileText size={20} className="text-orange-600" />;
    } else {
      return <File size={20} className="text-gray-500" />;
    }
  };

  // Formato para el tamaño del archivo - CORREGIDO
  const formatFileSize = (bytes) => {
    // Verificar si bytes existe y es válido
    if (!bytes || bytes === undefined || bytes === null) {
      return 'Desconocido';
    }
    
    // Convertir a número si es string
    const numBytes = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes;
    
    // Verificar que sea un número válido
    if (isNaN(numBytes) || numBytes < 0) {
      return 'Desconocido';
    }
    
    // Si es 0, retornar directamente
    if (numBytes === 0) {
      return '0 B';
    }
    
    const units = ['B', 'KB', 'MB', 'GB'];
    let size = numBytes;
    let unitIndex = 0;
    
    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
    
    // Asegurarse de que size sea un número antes de usar toFixed
    return `${Number(size).toFixed(1)} ${units[unitIndex]}`;
  };

  // Obtener nombre del tipo de archivo
  const getFileType = (mimeType) => {
    if (!mimeType) return 'Desconocido';
    
    const typeMap = {
      'application/pdf': 'PDF',
      'image/jpeg': 'JPEG',
      'image/png': 'PNG',
      'image/gif': 'GIF',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
      'application/msword': 'DOC',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
      'application/vnd.ms-excel': 'XLS',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
      'application/vnd.ms-powerpoint': 'PPT',
      'text/plain': 'TXT',
      'application/zip': 'ZIP',
      'application/x-rar-compressed': 'RAR'
    };
    
    return typeMap[mimeType] || mimeType.split('/')[1]?.toUpperCase() || 'Desconocido';
  };

  // Si está cargando, mostrar indicador
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-12 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg">
        <Loader size={40} className="text-blue-500 animate-spin mb-4" />
        <p className="text-gray-600 font-medium">Cargando archivos...</p>
      </div>
    );
  }

  // Si hay error, mostrar mensaje
  if (error) {
    return (
      <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
        <div className="flex items-center">
          <AlertCircle size={24} className="text-red-500 mr-3" />
          <div>
            <p className="text-red-700 font-medium">{error}</p>
            <button 
              onClick={loadFiles}
              className="mt-3 inline-flex items-center px-3 py-1.5 text-sm bg-red-100 text-red-700 hover:bg-red-200 rounded-md transition-colors"
            >
              <RefreshCw size={14} className="mr-1" />
              Intentar de nuevo
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Si no hay archivos, mostrar mensaje
  if (!Array.isArray(files) || files.length === 0) {
    return (
      <div className="text-center py-12 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border-2 border-dashed border-gray-300">
        <File size={48} className="text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600 font-medium text-lg">No hay archivos en esta tarea</p>
        <p className="text-gray-500 text-sm mt-2">Los archivos aparecerán aquí una vez que sean subidos</p>
      </div>
    );
  }

  // Renderizar lista de archivos
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold text-gray-800">
          Archivos de la tarea ({files.length})
        </h4>
        <button
          onClick={loadFiles}
          className="inline-flex items-center px-3 py-1.5 text-sm bg-blue-50 text-blue-600 hover:bg-blue-100 rounded-md transition-colors"
        >
          <RefreshCw size={14} className="mr-1" />
          Actualizar
        </button>
      </div>
      
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
        {/* Header para desktop */}
        <div className="hidden md:block bg-gray-50 border-b border-gray-200">
          <div className="grid grid-cols-12 gap-4 p-4 text-sm font-semibold text-gray-700">
            <div className="col-span-5">Nombre del archivo</div>
            <div className="col-span-2">Tipo</div>
            <div className="col-span-2">Tamaño</div>
            <div className="col-span-3 text-right">Acciones</div>
          </div>
        </div>
        
        <div className="divide-y divide-gray-200">
          {Array.isArray(files) && files.map((file, index) => (
            <div key={file.id || index} className="p-4 hover:bg-gray-50 transition-colors">
              {/* Vista desktop */}
              <div className="hidden md:grid grid-cols-12 gap-4 items-center">
                <div className="col-span-5 flex items-center min-w-0">
                  {getFileIcon(file.mimeType)}
                  <span className="ml-3 text-sm text-gray-900 truncate font-medium" title={file.name}>
                    {file.name}
                  </span>
                </div>
                <div className="col-span-2">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    {getFileType(file.mimeType)}
                  </span>
                </div>
                <div className="col-span-2 text-sm text-gray-600">
                  {formatFileSize(file.size)}
                </div>
                <div className="col-span-3 flex justify-end space-x-2">
                  {/* Ver archivo */}
                  <a
                    href={file.webViewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors"
                    title="Ver archivo"
                  >
                    <ExternalLink size={16} />
                  </a>
                  
                  {/* Descargar archivo 
                  <a
                    href={file.webContentLink}
                    download
                    className="p-2 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-md transition-colors"
                    title="Descargar archivo"
                  >
                    <Download size={16} />
                  </a>*/}
                  
                  {/* Eliminar archivo 
                  <button
                    //onClick={() => handleDeleteFile(file.id)}
                    className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                    title="Eliminar archivo"
                    disabled
                  >
                    <Trash2 size={16} />
                  </button>*/}
                </div>
              </div>

              {/* Vista mobile */}
              <div className="md:hidden">
                <div className="flex items-start justify-between">
                  <div className="flex items-center min-w-0 flex-1">
                    {getFileIcon(file.mimeType)}
                    <div className="ml-3 min-w-0 flex-1">
                      <p className="text-sm font-medium text-gray-900 truncate" title={file.name}>
                        {file.name}
                      </p>
                      <div className="flex items-center mt-1 space-x-2">
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                          {getFileType(file.mimeType)}
                        </span>
                        <span className="text-xs text-gray-500">
                          {formatFileSize(file.size)}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex space-x-1 ml-2">
                    <a
                      href={file.webViewLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-md"
                      title="Ver"
                    >
                      <ExternalLink size={16} />
                    </a>
                    <a
                      href={file.webContentLink}
                      download
                      className="p-2 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-md"
                      title="Descargar"
                    >
                      <Download size={16} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Información adicional */}
      <div className="mt-4 text-sm text-gray-500 text-center">
        Total de archivos: {files.length}
      </div>
    </div>
  );
};

export default FileViewer;